import { yupResolver } from "@hookform/resolvers/yup";
import { useMemo } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import * as Yup from "yup";
import { Button, IconButton } from "@mui/material";
import "react-quill/dist/quill.snow.css";
import ReactTextInput from "../../../components/ControllerComponent/ReactTextInput";
import ReactSelect from "../../../components/ControllerComponent/ReactSelect";
import ReactSelectAll from "../../../components/ControllerComponent/ReactSelectAll";
import { genderFullOptions } from "../../../constants";
import ReactSlider from "../../../components/ControllerComponent/ReactSlider";
import { Close } from "@mui/icons-material";

const NotificationsModal = ({ onSubmit, onClose }) => {
  const profileCategoryList = useSelector(
    (state) => state.profileCategoryReducer?.profileCategoryList ?? []
  );

  const profileCategoryOptions = useMemo(
    () =>
      profileCategoryList.map((item) => ({ label: item.name, value: item.id })),
    [profileCategoryList]
  );

  // Validation schema
  const validationSchema = Yup.object().shape({
    notificationTitle: Yup.string().required("Notification title required"),
    description: Yup.string().required("Message required"),
    kycStatus: Yup.string(),
    profileCategoryId: Yup.array(),
    gender: Yup.string(),
  });

  // Form control setup
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      notificationTitle: "",
      description: "",
      kycStatus: "",
      profileCategoryId: [],
      gender: "",
    },
  });

  const handleSavePress = (data) => {
    onSubmit(data);
  };

  return (
    <div className="flex flex-col h-full max-h-screen">
      <div className="absolute right-2 top-1 z-10 ">
        <IconButton onClick={onClose} className="rounded-full">
          <Close className="text-2xl rounded-full" />
        </IconButton>
      </div>

      <div className="flex items-center gap-2" style={{ height: "8%" }}>
        <h3 className="text-lg text-black">Notifications</h3>
      </div>

      <div
        className="flex-1 flex flex-col gap-4 overflow-y-auto px-2"
        style={{ maxHeight: "92%", paddingBottom: "1rem" }}
      >
        <ReactTextInput
          hookFormControl={control}
          label="Notification Title*"
          varName="notificationTitle"
          key={"notificationTitle"}
          maxLength={40}
          errorMessage={errors?.notificationTitle?.message}
        />

        <ReactTextInput
          hookFormControl={control}
          label={"Write your message"}
          varName="description"
          key={"description"}
          rows={5}
          maxLength={150}
          isMultiLine
          errorMessage={errors?.description?.message}
        />

        <div className=" gap-2 flex row-auto justify-between">
          <ReactSelectAll
            control={control}
            label="Profile Category"
            varName="profileCategoryId"
            name="profileCategoryId"
            data={profileCategoryOptions}
            multiSelect
            showSelectAll
          />

          <ReactSelect
            hookFormControl={control}
            label="Gender*"
            varName="gender"
            key={"gender"}
            options={genderFullOptions}
            errorMessage={errors?.gender?.message}
          />
        </div>

        <ReactSlider
          hookFormControl={control}
          label="Age Range"
          varName="ageRange"
          key={"ageRange"}
          minValue={0}
          maxValue={75}
          sx={{ color: "#000" }}
          errorMessage={errors?.ageRange?.message}
        />

        <Button
          variant="contained"
          className="bg-slate-600 text-white px-4 py-2 rounded-lg w-full items-center flex"
          onClick={handleSubmit(handleSavePress)}
        >
          Send to All
        </Button>
      </div>
    </div>
  );
};

export default NotificationsModal;
